export default __webpack_public_path__ + "maps-examples-view-annotation-marker-960-bbfd022ee2d678d8c9d7cd44fd85dbd7.webp";